<template>
  <v-chip
    small
    :class="`text-caption ${status === 'typical' ? 'black--text' : 'white--text'}`"
    :color="getColor(status)"
  >
    {{ getText(status) }}
  </v-chip>
</template>
<script>
export default {
  name: 'AdvantageChip',
  props: {
    status: {
      type: String,
      default: 'typical'
    }
  },
  methods: {
    getText(status) {
      switch (status) {
        case 'typical':
          return 'Hàng phổ thông'
        case 'exclusiveAdvance':
          return 'Độc quyền ưu thế'
        case 'exclusiveMass':
          return 'Độc quyền sỉ'
        case 'exclusiveAll':
          return 'Độc quyền toàn phần'
        default:
          return ''
      }
    },
    getColor(status) {
      switch (status) {
        case 'typical':
          return ''
        case 'exclusiveAdvance':
          return 'primary'
        case 'exclusiveMass':
          return 'green'
        case 'exclusiveAll':
          return 'red'
        default:
          return ''
      }
    }
  }
}
</script>
